import { AxiosResponse } from 'axios';
import ApiService from './api.service';
import { AdminEndpoint } from './api.endpoints';
import { AdminUserWrite, UserLogin } from '../types';

class AdminService extends ApiService {
  async createAdmin(payload: AdminUserWrite): Promise<AxiosResponse | undefined> {
    const response = await this.post(AdminEndpoint.REGISTER, payload);
    return response;
  }

  async loginAdmin(payload: UserLogin): Promise<AxiosResponse | undefined> {
    const response = await this.post(AdminEndpoint.LOGIN, payload);
    return response;
  }

  async updateAdmin(payload): Promise<AxiosResponse | undefined> {
    const response = await this.post(AdminEndpoint.UPDATE, payload);
    return response;
  }

  async fetchAdmin(): Promise<AxiosResponse | undefined> {
    const response = await this.get(AdminEndpoint.FETCH);
    return response;
  }

  async inviteAdmin(payload): Promise<AxiosResponse | undefined> {
    const response = await this.post(AdminEndpoint.INVITE, payload);
    return response;
  }

  async activateUser(payload): Promise<AxiosResponse | undefined> {
    const response = await this.post(AdminEndpoint.ACTIVATE, payload);
    return response;
  }

  async initiatePasswordReset(payload: any): Promise<AxiosResponse | undefined> {
    const response = await this.post(AdminEndpoint.INITIATE_PASSWORD_RESET, payload);
    return response;
  }

  async confirmPasswordReset(payload: any): Promise<AxiosResponse | undefined> {
    const response = await this.post(AdminEndpoint.CONFIRM_PASSWORD_RESET, payload);
    return response;
  }
}

export default AdminService;
